import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http"
import { inject } from "@angular/core"
import { Router } from "@angular/router"
import { AppRoute } from "@app-types/appRoute"
import { catchError, Observable, throwError } from "rxjs"

// A denied token is rejected during authentication and produces a 403 with no body on
// every endpoint. Ordinary authorization failures (wrong role / state) return a message
// body, so an empty-bodied 403 means access has been revoked for the account.
export const isAccessRevokedError = (err: unknown): boolean =>
    err instanceof HttpErrorResponse &&
    err.status === 403 &&
    (
        err.error == null ||
        err.error === '' ||
        (err.error instanceof Blob && err.error.size === 0) ||
        (err.error instanceof ArrayBuffer && err.error.byteLength === 0)
    )

export const accessRevokedInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const router = inject(Router)
    return next(req).pipe(
        catchError(err => {
            if (isAccessRevokedError(err)) {
                router.navigate([AppRoute.PATHS.accessRevoked])
            }
            return throwError(() => err)
        }),
    )
}
